<template>
<div class="chapter">
<div class="inner_page">
<h1 class="btnew"><a id="page_i"></a>T<span class="smallf">HIRTEEN MONTHS</span></h1>
<h1 class="btnew"><span class="smallf">IN</span></h1>
<h1 class="btnew1">D<span class="smallf"><span class="bold">IXIE,</span></span></h1>
<h1 class="btnew"><span class="smallf">OR, THE</span></h1>
<h1 class="btnew">A<span class="smallf">DVENTURES OF</span></h1>
<h1 class="btnew"><span class="smallf">A FEDERAL PRISONER</span></h1>
<h1 class="btnew"><span class="smallf">IN</span></h1>
<h1 class="btnew1">T<span class="smallf"><span class="bold">EXAS</span></span></h1>
<p class="bkaut">William Francis Oscar Federhen</p>
<p class="bkaut1">Jeaninne Surette Honstein and</p>
<p class="bkaut2">Steven A. Knowlton, editors</p>
<div class="img_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
<p class="logo">Savas Beatie</p>
<p class="logo">California</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?36ebb442